<h2 mat-dialog-title>Detalle del Usuario</h2>

<mat-dialog-content>
    <div class="user-header">
        <div class="avatar">
            <mat-icon>account_circle</mat-icon>
        </div>
        <div class="user-info">
            <div class="user-name">{{ user.name || 'Sin nombre' }}</div>
            <div class="user-email">{{ user.email }}</div>
            <div class="user-meta">
                <span class="status-badge status-{{ (user.status || 'unknown').toLowerCase() }}">
                    {{ user.status || 'No definido' }}
                </span>
                @if (user.createdAt) {
                <span class="created-at">Creado: {{ user.createdAt | date : 'dd/MM/yyyy HH:mm' }}</span>
                }
            </div>
        </div>
    </div>

    <div class="roles-section">
        <h4>
            <mat-icon>admin_panel_settings</mat-icon>
            Roles asignados
        </h4>
        @if (userRoles().length > 0) {
        <div class="roles-list">
            @for (role of userRoles(); track role.id) {
            <mat-chip-set>
                <mat-chip [disabled]="isSaving()">
                    {{ role.name }}
                    <button matChipRemove (click)="toggleRole(role)" [disabled]="isSaving()" matTooltip="Quitar rol">
                        <mat-icon>cancel</mat-icon>
                    </button>
                </mat-chip>
            </mat-chip-set>
            }
        </div>
        } @else {
        <p class="no-roles">Este usuario no tiene roles asignados.</p>
        }
    </div>

    <div class="roles-section">
        <h4>
            <mat-icon>add_circle_outline</mat-icon>
            Asignar rol
        </h4>
        @if (availableRoles().length > 0) {
        <div class="available-roles">
            @for (role of availableRoles(); track role.id) {
            <button mat-stroked-button (click)="toggleRole(role)" [disabled]="isSaving()"
                matTooltip="{{ role.description }}">
                <mat-icon>add</mat-icon>
                {{ role.name }}
            </button>
            }
        </div>
        } @else {
        <p class="no-roles">No hay más roles disponibles. Cree roles nuevos en la sección de arriba.</p>
        }
    </div>

    @if (userRoles().length > 0) {
    <div class="permissions-summary">
        <h4>
            <mat-icon>key</mat-icon>
            Permisos efectivos
        </h4>
        <div class="permissions-chips">
            @for (perm of uniquePermissions(); track perm) {
            <span class="permission-chip">{{ perm }}</span>
            }
        </div>
    </div>
    }
</mat-dialog-content>

<mat-dialog-actions align="end">
    @if (isSaving()) {
    <mat-spinner diameter="20"></mat-spinner>
    }
    <button mat-raised-button color="primary" (click)="onClose()">Cerrar</button>
</mat-dialog-actions>
